import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = ({ size = 'medium', showLabel = false }) => {
  const { mode, toggleTheme, isDark } = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
        <IconButton
          onClick={toggleTheme}
          size={size}
          sx={{
            color: isDark ? '#fbbf24' : '#6b7280',
            backgroundColor: isDark ? 'rgba(251, 191, 36, 0.1)' : 'rgba(107, 114, 128, 0.1)',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: isDark ? 'rgba(251, 191, 36, 0.2)' : 'rgba(107, 114, 128, 0.2)',
              transform: 'rotate(15deg)',
            },
          }}
        >
          {isDark ? <Sun size={20} /> : <Moon size={20} />}
        </IconButton>
      </Tooltip>
      {showLabel && (
        <Box
          component="span"
          sx={{
            fontSize: '0.875rem',
            color: 'text.secondary',
            fontWeight: 500,
          }}
        >
          {mode === 'dark' ? 'Dark' : 'Light'}
        </Box>
      )}
    </Box>
  );
};

export default ThemeToggle;
